module.exports = __webpack_public_path__ + "bin/c119bd1638f4a114510c6f91e313ad81.png";